// extracted by mini-css-extract-plugin
module.exports = {"postTitle":"ch_nd","postTitle_size_1":"ch_nf","postTitle_size_2":"ch_ng","postTitle_size_3":"ch_nh"};